import {
  Text,
  Group,
  Stack,
  Loader,
  Box,
  Collapse,
  UnstyledButton,
  Divider,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import { usePendingStains } from "../../hooks/useStainRequest";
import { PendingStainItem } from "./PendingStainItem";

interface PendingStainsPanelProps {
  caseId: string;
  caseNumber?: string;
  onPendingCountChange?: (count: number) => void;
}

export default function PendingStainsPanel({
  caseId,
  caseNumber,
  onPendingCountChange,
}: PendingStainsPanelProps) {
  const [opened, { toggle }] = useDisclosure(true);
  const { data: pendingStains, isLoading } = usePendingStains(caseId);

  if (onPendingCountChange && pendingStains) {
    onPendingCountChange(pendingStains.length);
  }

  if (!isLoading && (!pendingStains || pendingStains.length === 0)) {
    return null;
  }

  const stainCount = pendingStains?.length ?? 0;

  return (
    <Box>
      <UnstyledButton onClick={toggle} w="100%">
        <Group gap={6}>
          {opened ? (
            <IconChevronDown size={12} color="var(--mantine-color-dimmed)" />
          ) : (
            <IconChevronRight size={12} color="var(--mantine-color-dimmed)" />
          )}
          <Text size="sm" fw={500}>
            {stainCount} Pending Stain{stainCount !== 1 ? "s" : ""}
          </Text>
        </Group>
      </UnstyledButton>

      <Collapse in={opened}>
        <Divider my={6} />
        {isLoading ? (
          <Box ta="center" py="xs">
            <Loader size="xs" />
          </Box>
        ) : (
          <Stack gap={8}>
            {pendingStains?.map((stain) => (
              <PendingStainItem
                key={stain.id}
                stain={stain}
                caseId={caseId}
                caseNumber={caseNumber}
              />
            ))}
          </Stack>
        )}
      </Collapse>
    </Box>
  );
}
